import { RadioButtonItem } from 'components/core/radio-button-group';
import { IntlShape } from 'react-intl';

export type DateFilterType = typeof DATE_FILTER_TYPE[keyof typeof DATE_FILTER_TYPE];

export type DateFilterValue = {
	startDate?: Date;
	endDate?: Date;
	type: DateFilterType;
};

export type DateFilterRadioButtonItem = Omit<RadioButtonItem, 'id'> & {
	id: DateFilterType;
};

export const DATE_FILTER_TYPE = {
	CUSTOM: 'custom',
	LAST_WEEK: 'lastWeek',
	LAST_MONTH: 'lastMonth',
	LAST_THREE_MONTHS: 'last3Months',
	ALL: 'all'
} as const;

export const getDateFilterItems = (intl: IntlShape): DateFilterRadioButtonItem[] => [
	{
		id: DATE_FILTER_TYPE.ALL,
		label: intl.formatMessage({ id: 'modules.searchOverview.dateFilter.all' })
	},
	{
		id: DATE_FILTER_TYPE.LAST_WEEK,
		label: intl.formatMessage({ id: 'modules.searchOverview.dateFilter.lastWeek' })
	},
	{
		id: DATE_FILTER_TYPE.LAST_MONTH,
		label: intl.formatMessage({ id: 'modules.searchOverview.dateFilter.lastMonth' })
	},
	{
		id: DATE_FILTER_TYPE.LAST_THREE_MONTHS,
		label: intl.formatMessage({ id: 'modules.searchOverview.dateFilter.last3Months' })
	},
	{
		id: DATE_FILTER_TYPE.CUSTOM,
		label: intl.formatMessage({ id: 'modules.searchOverview.dateFilter.choose' })
	}
];
